import React from 'react';

import { Flex } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { noOp } from 'constants/helper';

import { Radio } from 'uiToolkitV1/Radio';
import { Tooltip } from 'uiToolkitV1/Tooltip';

type Props = {
  rowData: any;
  selectedId: string;
  isDisabled: boolean;
  onSelect?: (goal: Record<string, any>) => void;
};

const RadioButton = ({ rowData, selectedId, isDisabled, onSelect }: Props) => {
  const { moduleName } = useOrganisationSettings();
  const isSelected = selectedId === rowData.uuid;

  return (
    <Flex w="100%" h="100%">
      <Tooltip fontSize="14px" label={`Select this ${moduleName}`}>
        <Flex alignItems="center">
          {/* @ts-ignore */}
          <Radio
            isChecked={isSelected}
            isDisabled={isDisabled}
            name={rowData.uuid}
            onClick={() => (isDisabled ? noOp() : onSelect(rowData))}
          />
        </Flex>
      </Tooltip>
    </Flex>
  );
};

export default RadioButton;
